import { render } from "./OrdersHistory.vue?vue&type=template&id=b733daf6"
import script from "./OrdersHistory.vue?vue&type=script&lang=js"
export * from "./OrdersHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__